import { PermissionStatus } from 'features/pay/types/types';
export const mapIOSPermissions = (result) => {
    switch (result) {
        case 'granted':
        case 'authorized':
        case 'limited':
            return PermissionStatus.allowed;
        case 'restricted':
        case 'denied':
            return PermissionStatus.banned;
        default:
            return PermissionStatus.unknown;
    }
};
